import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { EBuyPackageStatus } from '../../reducers/types';

export const SET_BUY_PACKAGE_STATUS = 'BUY_PACKAGE :: STATUS';

interface IBuyPackageStatus {
  status: EBuyPackageStatus;
}

export type TSetBuyPackageStatusAction = IReduxAction<typeof SET_BUY_PACKAGE_STATUS, IBuyPackageStatus>;

export const setBuyPackageStatus = actionGenerator<typeof SET_BUY_PACKAGE_STATUS, IBuyPackageStatus>(
  SET_BUY_PACKAGE_STATUS,
);
